import { createFeatureSelector, createSelector } from "@ngrx/store";
import * as fromOrders from '@core/state/order/order.reducers';
import { mapToOrderStage } from '@core/models/order-stage';

export const selectOrderState = createFeatureSelector<fromOrders.State>('order');
export const selectOrders = createSelector(selectOrderState, state => state.orders); // get all orders
export const selectOrdersDetail = createSelector(selectOrderState, state => state.ordersDetail); // get all order detail
export const selectOrdersDetailV2 = createSelector(selectOrderState, state => state.ordersDetailV2); // get all order detail v2
export const selectDesignImages = createSelector(selectOrderState, state => state.designImages); // get all design images

export const selectOrderSizeColors = createSelector(selectOrdersDetail, (data) => {
    let results: any;
    let design: any;
    let products = [];
    if(data) {
        results = data
        design = results.data.designs

        design.map(product => {
            products.push(product.products)
        })
    }
    return products
})

export const selectOrderSizeColorsDetail = createSelector(selectOrdersDetail, (data) => {
    let results: any;
    let design: any;
    let products = [];
    let sizeColors = [];
    if(data) {
        results = data
        design = results.data.designs

        design.map(product => {
            products.push(product.products)
        })

        if(products.length > 0) {
            Object.values(products).forEach(sc => {
                sc.map(scData => {
                    sizeColors.push(scData.size_colors)
                })
            })

        }

    }
    return sizeColors
})

export const selectOrderHeaders = createSelector(selectOrderState, state => state.headers);

export const selectOrderTableHeaders = createSelector(selectOrderHeaders, (data) => {
    // The tabs are fixed categories, so always return all four — even before the
    // headers/counts endpoint responds — so the orders list still renders if that
    // (separate) endpoint is slow or fails. Counts are null until headers arrive.
    return [
        { title: 'All', count: data ? (data.estimateCount + data.completedCount + data.productionCount) : null },
        { title: 'Estimate', count: data ? data.estimateCount : null },
        { title: 'Production', count: data ? data.productionCount : null },
        { title: 'Completed', count: data ? data.completedCount : null }
    ];
})
// export const selectOrderCounts = createSelector(selectOrders, (data) => {
//     let results: number | 0;
//     if(data){
       
//         results = data.length;
//     }
//     return results
// })

// export const selectAllOrders = createSelector(selectOrders, (data) => {
//     let results: any;
//     if(data){
//         results = data.map(filteredO => {
//             return {
//                 orderId : filteredO.display_number,
//                 jobName : filteredO.name,
//                 po : filteredO.custom_po,
//                 orderPlaced : filteredO.created_date,
//                 garmentArrivalDate : filteredO.garment_date,
//                 shipDate : filteredO.date_shipped,
//                 inHandsDate : filteredO.in_hands_by,
//                 status : filteredO.approval_id.cpstatus.label,
//                 mockup_img: filteredO.mockup_img
//             }
//         })
//         results.sort((a,b) => {
//             if(a.orderId > b.orderId) return -1;
//             if(a.orderId < b.orderId) return 1;
//             return 0;
//         })
//     }
    
//     return results
// })
export const selectProductionOrders = createSelector(selectOrders, (data) => {
    let results: any;
    if(data){
        // results = data.filter(o => {
        //     let status = o.approval_id['cpstatus']['label']
        //     return status == 'In Production' || status == 'Art'
        // }).map(filteredO => {
        //     return {
        //         orderId : filteredO.display_number,
        //         jobName : filteredO.name,
        //         po : filteredO.custom_po,
        //         orderPlaced : filteredO.created_date,
        //         garmentArrivalDate : filteredO.garment_date,
        //         shipDate : filteredO.date_shipped,
        //         inHandsDate : filteredO.in_hands_by,
        //         status : filteredO.approval_id.cpstatus.label,
        //         mockup_img: filteredO.mockup_img
        //     }
        // })
        results.sort((a,b) => {
            if(a.orderId > b.orderId) return -1;
            if(a.orderId < b.orderId) return 1;
            return 0;
        })
    }
    return results
})
export const selectProductionOrderCounts = createSelector(selectOrders, (data) => {
    let results: number | 0;
    if(data){
        // let orders = data.filter(o => {
        //     let status = o.approval_id['cpstatus']['label']
        //     return status == 'In Production' || status == 'Art'
        // })
        // results = orders.length;
    }
    return results
})
export const selectEstimateOrders = createSelector(selectOrders, (data) => {
    let results: any;
    if(data){
        // results = data.filter(o => {
        //     let status = o.approval_id['cpstatus']['label']
        //     return status == 'Under Review'
        // }).map(filteredO => {
        //     return {
        //         orderId : filteredO.display_number,
        //         jobName : filteredO.name,
        //         po : filteredO.custom_po,
        //         orderPlaced : filteredO.created_date,
        //         garmentArrivalDate : filteredO.garment_date,
        //         shipDate : filteredO.date_shipped,
        //         inHandsDate : filteredO.in_hands_by,
        //         status : filteredO.approval_id.cpstatus.label,
        //         mockup_img: filteredO.mockup_img
        //     }
        // })
        results.sort((a,b) => {
            if(a.orderId > b.orderId) return -1;
            if(a.orderId < b.orderId) return 1;
            return 0;
        })
    }
    return results
})
export const selectEstimateOrderCounts = createSelector(selectOrders, (data) => {
    let results: number | 0;
    if(data){
        // let orders = data.filter(o => {
        //     let status = o.approval_id['cpstatus']['label']
        //     return status == 'Under Review'
        // })
        // results = orders.length;
    }
    return results
})
export const selectCompletedOrders = createSelector(selectOrders, (data) => {
    let results: any;
    if(data){
        // results = data.filter(o => {
        //     let status = o.approval_id['cpstatus']['label']
        //     return status == 'Shipped' || status == 'Payment' || status == 'Fulfilled'
        // }).map(filteredO => {
        //     return {
        //         orderId : filteredO.display_number,
        //         jobName : filteredO.name,
        //         po : filteredO.custom_po,
        //         orderPlaced : filteredO.created_date,
        //         garmentArrivalDate : filteredO.garment_date,
        //         shipDate : filteredO.date_shipped,
        //         inHandsDate : filteredO.in_hands_by,
        //         status : filteredO.approval_id.cpstatus.label,
        //         mockup_img: filteredO.mockup_img
        //     }
        // })
        results.sort((a,b) => {
            if(a.orderId > b.orderId) return -1;
            if(a.orderId < b.orderId) return 1;
            return 0;
        })
    }
    return results
})

export const selectCompletedOrderCounts = createSelector(selectOrders, (data) => {
    let results:number | 0;
    if(data){
        // let orders = data.filter(o => {
        //     let status = o.approval_id['cpstatus']['label']
        //     return status == 'Shipped' || status == 'Payment' || status == 'Fulfilled'
        // })
        // results = orders.length;
    }
    return results
})

// export const selectOrderHeaderCounts = createSelector(selectOrders, (data) => {
//     let headers = []
//     if(data){      
//         let allOrderCounts = data.estimateCount + data.productionCount + data.completedCount;
//         let estimateOrderCounts = data.estimateCount;
//         let productionOrderCounts = data.productionCount;
//         let completedOrderCounts = data.completedCount;

//         headers = [ {title: 'All', counts: allOrderCounts},{title: 'Estimates', counts: estimateOrderCounts}, {title: 'Production', counts: productionOrderCounts},  {title: 'Completed', counts: completedOrderCounts} ]
        
//         return headers;
//     }
// })


// ----- Helpers for the redesigned orders table (Story 11.6) -----
// The list endpoint now returns contact, distributions (location/tracking),
// grand_total and balance_due per order. Field names below are best-effort and
// may need confirming against the live response (see docs/redesign-divergences.md 11.6-b).
function mainContactName(o: any): string {
    const c = o?.contact_main ?? o?.main_contact ?? o?.contact ?? null;
    if (!c) { return null; }
    return c.name ?? ([c.first_name, c.last_name].filter(Boolean).join(' ') || null);
}
export function primaryDistribution(o: any): any {
    const dists = o?.distributions ?? [];
    return dists.find((d: any) => Number(d?.is_ship_to) === 1) ?? dists[0] ?? null;
}
function distributionTracking(d: any): string {
    if (!d) { return null; }
    if (Array.isArray(d.tracking_numbers)) { return d.tracking_numbers[0] ?? null; }
    return d.tracking_number ?? null;
}

/**
 * Map one raw order record from the list endpoint into the view-model the orders
 * table (and the Orders-home pipeline) render. Exported so both the table selector
 * and the self-fetching pipeline produce identical row shapes.
 */
export function mapOrderListItem(filteredO: any): any {
    const primary = primaryDistribution(filteredO);
    const anyO: any = filteredO;
    // Granular internal status (falls back to the coarse client-portal label).
    const rawStatus = filteredO.approval_id?.value ?? filteredO.approval_id?.cpstatus?.label;
    return {
        orderId : filteredO.display_number,
        jobName : filteredO.name,
        po : filteredO.custom_po,
        orderPlaced : filteredO.created_date,
        garmentArrivalDate : filteredO.garment_date,
        shipDate : filteredO.date_shipped,
        inHandsDate : filteredO.in_hands_by,
        status : rawStatus,
        // Normalized pipeline stage derived from the order status (CS-3428).
        mappedStatus : mapToOrderStage(filteredO),
        mockup_img: filteredO.mockup_img,
        // Story 11.6: real values from the updated list endpoint
        // (confirmed keys: `total`, `open_balance`).
        total: anyO.total ?? anyO.grand_total ?? null,
        openBalance: anyO.open_balance ?? anyO.balance_due ?? null,
        contact: mainContactName(filteredO),
        // The backend now sends the order's location directly (was derived from
        // the primary distribution's city/state).
        location: filteredO.location ?? null,
        tracking: distributionTracking(primary),
        trackingType: primary?.shipping_type ?? primary?.third_party_shipping_type ?? null,
        distributions: filteredO.distributions ?? []
    };
}

export const selectAllOrders = createSelector(selectOrders, (res) => {
    let result: any;
    if(res){
        let orders = res.data;
        result = orders.map(mapOrderListItem)
        result.sort((a,b) => {
            if(a.orderId > b.orderId) return -1;
            if(a.orderId < b.orderId) return 1;
            return 0;
        })
        return {
            data: result,
            totalCount: res.totalCount,
            page: res.page,
            limit: res.limit,
        };
    }
})

